export default "__VITE_ASSET__bTA07v81__"